export const FETCH_VOUCHER_SUCCESS = "FETCH_VOUCHER_SUCCESS";
